import React, { Component } from 'react';
import { Row, Col, Input, Checkbox, Divider, Button, message, Slider } from 'antd';
import { connect } from "react-redux";
import cookie from "react-cookies";
import axios from 'axios';
import { AuthHeader } from '../../../helper/auth.token';
import { scanWorkflowLoadingMessages } from '../../../utils/const';
import { updateActionOngoing } from '../../../action/preview_status.action';

class CameraSettings extends Component {
    constructor(props) {
        super(props);
        this.state = {
            exposureInputValue: 20,
            gammaInputValue: 1,
            inputFieldInFocus: false,
            livemodeConfig: {},
        }
    }

    componentDidMount = () => {
        this.props.dispatch(updateActionOngoing(this.props.id, true, scanWorkflowLoadingMessages.LOADING));
        let partsOfUrl = "api~scan~get_camera_info";
        let url = `/server/scano/` + this.props.device_id + `/` + partsOfUrl + "/?objectiveType=" + this.props.preview.objectiveType;
        axios.get(url, { headers: { Authorization: AuthHeader() } })
            .then(response => {
                if (response.status === 200) {
                    console.log(response);
                    this.setState({
                        exposureInputValue: response.data.cameraConfig.exposureTime,
                        gammaInputValue: response.data.cameraConfig.gamma,
                        livemodeConfig: response.data.livemodeConfig,
                    });
                }
                else {
                    console.log(response);
                    message.error("Not able to get camera settings!!", 2.5);
                }
                this.props.dispatch(updateActionOngoing(this.props.id, false, scanWorkflowLoadingMessages.EMPTY_MESSAGE));
            })
            .catch(err => {
                console.log(err);
                message.error("Not able to get camera settings!!", 2.5);
                this.props.dispatch(updateActionOngoing(this.props.id, false, scanWorkflowLoadingMessages.EMPTY_MESSAGE));
            })
    }

    setExposureValue = (value) => {
        this.props.dispatch(updateActionOngoing(this.props.id, true, scanWorkflowLoadingMessages.SET_EXPOSURE_VALUE));
        let partsOfUrl = "api~scan~set_exposure";
        let url = `/server/scano/` + this.props.device_id + `/` + partsOfUrl + "/?exposure=" + value + "&objectiveType=" + this.props.preview.objectiveType;
        axios.get(url, { headers: { Authorization: AuthHeader() } })
            .then(response => {
                if (response.status === 200) {
                    this.setState({
                        exposureInputValue: response.data['exposureTime']
                    });
                    this.props.getFortyXImageDDPoint();
                    message.success("Exposure set successfully!!", 2.5);
                }
                else {
                    console.log(response);
                    message.error("Not able to set exposure!!", 2.5);
                    this.props.dispatch(updateActionOngoing(this.props.id, false, scanWorkflowLoadingMessages.EMPTY_MESSAGE));
                }
            })
            .catch(err => {
                console.log(err);
                message.error("Not able to set exposure!!", 2.5);
                this.props.dispatch(updateActionOngoing(this.props.id, false, scanWorkflowLoadingMessages.EMPTY_MESSAGE));
            })
    }

    setGammaValue = (value) => {
        this.props.dispatch(updateActionOngoing(this.props.id, true, scanWorkflowLoadingMessages.SET_GAMMA_VALUE));
        let partsOfUrl = "api~scan~set_gamma";
        let url = `/server/scano/` + this.props.device_id + `/` + partsOfUrl + "/?gamma=" + value + "&objectiveType=" + this.props.preview.objectiveType;
        axios.get(url, { headers: { Authorization: AuthHeader() } })
            .then(response => {
                if (response.status === 200) {
                    this.setState({
                        gammaInputValue: response.data['gamma']
                    });
                    this.props.getFortyXImageDDPoint();
                    message.success("Gamma set successfully!!", 2.5);
                }
                else {
                    console.log(response);
                    message.error("Not able to set gamma!!", 2.5);
                    this.props.dispatch(updateActionOngoing(this.props.id, false, scanWorkflowLoadingMessages.EMPTY_MESSAGE));
                }
            })
            .catch(err => {
                console.log(err);
                message.error("Not able to set gamma!!", 2.5);
                this.props.dispatch(updateActionOngoing(this.props.id, false, scanWorkflowLoadingMessages.EMPTY_MESSAGE));
            })
    }

    exposureValueChange = (value) => {
        this.setState({
            exposureInputValue: value
        });
    }

    gammaValueChange = (value) => {
        this.setState({
            gammaInputValue: value
        });
    }

    onFocusInputField = () => {
        this.setState({
            inputFieldInFocus: true,
        });
    }

    onBlurInputField = () => {
        this.setState({
            inputFieldInFocus: false,
        });
    }

    getCameraSliderRow = (haveRowStyle, heading, slider) => {
        return (
            <Row style={haveRowStyle ? { marginTop: 5 } : {}}>
                <Col span={7}>
                    <b>{heading}</b>
                </Col>
                <Col span={14}>
                    {slider}
                </Col>
            </Row>
        )
    }

    render() {

        let minExposureValue = this.state.livemodeConfig.minExposure != undefined ? this.state.livemodeConfig.minExposure : 5;
        let maxExposureValue = this.state.livemodeConfig.maxExposure != undefined ? this.state.livemodeConfig.maxExposure : 25;

        let minGammaValue = this.state.livemodeConfig.minGamma != undefined ? this.state.livemodeConfig.minGamma : 0.1;
        let maxGammaValue = this.state.livemodeConfig.maxGamma != undefined ? this.state.livemodeConfig.maxGamma : 1;

        return (
            <Row>
                <Col span={24}>
                    {this.getCameraSliderRow(false, 'Exposure',
                        <Slider value={this.state.exposureInputValue} min={minExposureValue} max={maxExposureValue} onAfterChange={this.setExposureValue} 
                            onChange={this.exposureValueChange} style={{padding: 0, margin: '8px 0px 0px 0px'}}  
                        />
                    )}
                    {this.getCameraSliderRow(true, 'Gamma',
                        <Slider value={this.state.gammaInputValue} min={minGammaValue} max={maxGammaValue} step={0.1} onAfterChange={this.setGammaValue} 
                            onChange={this.gammaValueChange} style={{padding: 0, margin: '8px 0px 0px 0px'}} 
                        />
                    )}
                </Col>
            </Row>
        )
    }
}

const mapStateToProps = (state, ownProps) => {
    return {
		preview: state.previewStatusReducer[ownProps.id],
    };
};

export default connect(mapStateToProps)(CameraSettings);
